import { Skeleton } from '@heroui/react';

import { DeploymentTime } from '~/components/DeploymentTime';

export type DeployedByCellProps = {
  deployedBy: string;
  deploymentTime: string;
  engineVersion: string;
};

export function DeployedByCell({
  deployedBy,
  deploymentTime,
  engineVersion
}: DeployedByCellProps) {
  if (!deployedBy) {
    return null;
  }

  return (
    <div className='flex flex-col gap-1 text-nowrap'>
      <p className='-mb-2'>{deployedBy}</p>
      <DeploymentTime
        timestamp={deploymentTime}
        engineVersion={engineVersion}
      />
    </div>
  );
}

export function DeployedByCellSkeleton() {
  return (
    <div className='flex flex-col gap-1 text-nowrap'>
      <Skeleton className='h-4 w-24 rounded' />
      <Skeleton className='h-3 w-20 rounded' />
    </div>
  );
}
